<script lang="ts">
  import { Col, Table } from "sveltestrap";
  import Card from "../../../Core/Card.svelte";
  import {
    ExtraLargeTables,
    ExtraLargeTablesMessage,
  } from "../../../../utils/Constant/Constant";
  import {
    tableheader,
    tableoptionsbody,
  } from "../../../../Data/Table/SveltestrapTable/SveltestrapTable";
</script>

<Col sm="12">
  <Card headerTitle={ExtraLargeTables} cardHeaderprops="pb-0">
    <div slot="customheader">
      <span>{@html ExtraLargeTablesMessage}</span>
    </div>
    <div slot="contentbody">
      <div class="table-responsive custom-scrollbar ">
        <Table size="xl">
          <thead>
            <tr>
              {#each tableheader as tableItem}
                <th scope="col">{tableItem}</th>
              {/each}
            </tr>
          </thead>
          <tbody>
            {#each tableoptionsbody as tableItem}
              <tr>
                <th scope="row">{tableItem.num}</th>
                <td>{tableItem.name}</td>
                <td>{tableItem.lname}</td>
                <td>{tableItem.username}</td>
              </tr>
            {/each}
          </tbody>
        </Table>
      </div>
    </div>
  </Card>
</Col>
